import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconVerified from 'components/icons/iconVerified';
import CtaButton from 'components/essentials/Cta/CtaButton';
import ReviewStars from 'components/consumer/ReviewStars';
import SanitizedHtml from 'components/consumer/SanitizedHtml';

const maxWords = 60;

const getFullName = name => {
  if (!name) {
    return null;
  }
  const formattedName = name.split(' ').splice(0, 2);
  if (formattedName[1]) {
    formattedName[1] = formattedName[1].charAt(0);
  }
  return formattedName.join(' ');
};

class ReviewCard extends React.Component {
  constructor(props) {
    super(props);
    const { productReview } = props;
    const collapsed = productReview.comment
      ? productReview.comment.split(' ').length > maxWords
      : false;
    this.state = {
      collapsed,
    };
  }

  printText(text) {
    if (this.state.collapsed) {
      return `${text
        .split(' ')
        .splice(0, maxWords)
        .join(' ')} ...`;
    }
    return text;
  }

  toggleText() {
    const { collapsed } = this.state;
    this.setState({
      collapsed: !collapsed,
    });
  }

  render() {
    const { productReview } = this.props;
    const review = productReview.reviews
      ? productReview.reviews[0]
      : productReview;
    if (!review) {
      return null;
    }
    const comment = this.printText(review.comment);
    const fullName = getFullName(review.full_name);
    return (
      <div
        key={review.id}
        className={classNames(
          'min-w-[280px] rounded-sm mt-[.15rem] mr-[2.5em] mb-[.15rem] ml-0 text-left w-full overflow-y-scroll',
          'max-[569px]:max-w-full max-[569px]:mr-8',
          'md:mx-4 md:my-[.15rem] md:min-h-[350px]',
          'lg:min-h-[400px] lg:p-8 lg:mt-0 lg:mr-4 lg:mb-0 lg:ml-0 lg:bg-gray-light9 lg:h-full'
        )}
      >
        <div className="text-base text-gray [&_svg]:ml-[7px] [&_g]:stroke-[#107c8c]">
          {fullName}
          <IconVerified />
        </div>
        <div className="my-[.3rem]">
          <ReviewStars rating={review.rate} readOnly size="sm" />
        </div>

        <SanitizedHtml
          className="text-lg font-bold text-gray mx-0 my-3 first-letter:capitalize"
          html={review.title}
        />

        <div className="text-sm">
          <SanitizedHtml as="span" html={comment} />

          {this.state.collapsed && (
            <>
              &nbsp;
              <CtaButton
                styling="link"
                hasArrow={false}
                color="brand"
                size="sm"
                className="text-brand cursor-pointer mt-4 hover:underline"
                onClick={() => this.toggleText()}
              >
                Read More
              </CtaButton>
            </>
          )}
        </div>
      </div>
    );
  }
}

ReviewCard.propTypes = {
  productReview: PropTypes.shape({
    comment: PropTypes.string,
    reviews: PropTypes.array,
  }),
};

export default ReviewCard;
